// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  zh: {
    disclosure: require('../language/zh-CN/disclosure.json'),
    vulnerability: require('../language/zh-CN/vulnerability.json')
  },
  en: require('../language/en-US/vulnerability.json'),
  DE: require('../language/de-DE/vulnerability.json')
};


const i18n = new VueI18n({
  locale: 'zh',
  messages
});

export default i18n;
